import React, {useEffect} from 'react';
import WishlistHeartRecoWrapper from '@wishlist/components/WishlistHeartRecoWrapper.jsx';
import SoldOutRecommendation from "./sold-out/SoldOutRecommendation.jsx";
import MessageBroker from "@bonprix/pattern-library/components/message-broker";
import {SideSectionAction} from "@product/sections/SideSectionAction.tsx";

export default function ProductAlternatives({
                                                itemNumber,
                                                shopId,
                                                productAlternativesDataUrl,
                                                excludedStyleIds = [],
                                                texts
                                            }) {
    const paramStringWithExclusionIds =
        `?itemNumber=${itemNumber}&shopId=${shopId}` + `&excludedDigistyleIds=${excludedStyleIds.join(',')}`;

    useEffect(() => {
        const detailsComponent = (
            <SoldOutRecommendation
                paramString={paramStringWithExclusionIds}
                dataUrl={productAlternativesDataUrl}
                className="sold-out-carousel-slider"
            >
                <WishlistHeartRecoWrapper />
            </SoldOutRecommendation>
        );

        MessageBroker.publish(SideSectionAction.OPEN, {
            nodes: {
                title: texts['ada_psm_headline'],
                content: detailsComponent
            }
        });
    }, []);
}
